import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { ORG_API_URL_PARAM } from '@y42/model';
import { BaseStorageService } from '@y42/services/storage';

@Injectable({ providedIn: 'root' })
export class OrgScopeStorageService extends BaseStorageService {
  constructor() {
    super(`${environment.url.frontend_storage_api}/company/${ORG_API_URL_PARAM}/storage`);
  }
}
